module.exports = __webpack_public_path__ + "turn_sharp_left.svg?812bdcdfb29cd5a5a588a6d7d9fee781";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/turn_sharp_left.svg
// module id = 226
// module chunks = 0